import React, {memo} from 'react';
import {InputCheckbox} from "../../../utils/checkbox/InputCheckbox";

function ChatListSearchAll({search_all, handleChange}) {
  const onChange = (field, value) => {
    handleChange(field, value);
  };

  return <div className="sidebar-chat__dropdown">
    <InputCheckbox type="checkbox" checked={search_all} title="All" count={''} name="search_all" onChange={onChange}/>
  </div>;
};

export default memo(ChatListSearchAll, (prevProps, nextProps) => {
  return prevProps.search_all === nextProps.search_all
});